module.exports = __webpack_public_path__ + "img/play.a990b06e.svg";